<template>
  <div class="mb-5">
    <div class="d-flex align-center justify-space-between pt-3 mb-3">
      <div class="ps-3">
        <h2 class="mb-0 font-weight-bold">{{ $t('setting.title') }} {{ $t('bill.bill_price') }}</h2>
      </div>
      <div class="d-flex align-center justify-end gap-2">
        <v-btn
        v-if="!isShowSelect"
        class=" white--text mx-1"
        color="info"
        outlined
        :disabled="isMainLoading"
        @click="openSelectArea()">
          <v-icon class="me-2">mdi-cog</v-icon>{{ $t('market.setting_multiple_stall') }}
        </v-btn>
        <template v-if="isShowSelect">
          <v-btn
            class=" white--text mx-1"
            color="info"
            outlined
            :disabled="isMainLoading || selectAreas.length == 0"
            @click="settingListClick()"
          >
            <v-icon class="me-2">mdi-plus</v-icon>
            {{ $t('market.setting_all_stall', { count: selectAreas.length }) }}
          </v-btn>
          <v-btn class="white--text mx-1" :disabled="isMainLoading || selectAreas.length == 0" color="error" outlined
            @click="removeBillingSettings()">
            <v-icon class="me-2">mdi-trash-can</v-icon>
            {{ $t('delete_settings') }} {{ selectAreas.length }} {{ $t('area.title') }}
          </v-btn>
          <v-btn
            class="error mx-1"
            :disabled="isMainLoading"
            @click="selectAreasClear();  isShowSelect = false"
          >{{ $t('cancel') }}</v-btn>
        </template>
        <v-btn @click="exportAreaAccounting()" class="blue white--text" :disabled="isMainLoading">
          <v-icon class="me-2">mdi-file-excel-outline</v-icon>Export Excel
        </v-btn>
      </div>
    </div>
    <v-card flat outlined :loading="isMainLoading" min-height="30">
      <v-data-table
        fixed-header
        :items-per-page="10"
        :headers="areasAccountingItems.headers"
        :items="areasAccountingItems.items"
        class="elevation-0 outlined"
        :class="isShowSelect ? 'acc-table-select' : 'acc-table-non-select'"
        sort-by="area.order"
        :loading="isMainLoading"
        :show-select="isShowSelect"
        @toggle-select-all="selectAllToggle"
      >
        <template v-slot:item="{ item,index }">
          <tr :data-id="item.id">
            <td class="text-left fix-col-row" v-if="isShowSelect">
              <v-simple-checkbox
                :value="item.isSelected"
                @input="inputSelectAreas(item,item.isSelected)"
              ></v-simple-checkbox>
            </td>
            <td class="text-center fix-col-row">{{index+1}}</td>
            <td class="text-center fix-col-row">{{item.area.name}}</td>
            <template v-for="header, indexIn in areasAccountingItems.headers">
              <template v-if="header.value !== 'area.name' && header.value !== 'area.order' && header.value !== 'action'">
                <td class="text-center" :key="indexIn" width="100px">
                  <template v-if="item[header.value]">
                    <template v-if="item[header.value].accountingProduct && item[header.value].accountingProduct.type == 'discount' && item[header.value].discount">
                      {{ item[header.value].discount * -1 | currency }}
                    </template>
                    <template v-if="item[header.value].accountingProduct && item[header.value].accountingProduct.type != 'discount' && item[header.value].cost">
                      {{ item[header.value].cost | currency }}
                    </template>
                  </template>
                  <v-btn
                    v-if="!isShowSelect"
                    text
                    icon
                    small
                    @click="updateAreaAccountingProuctDialog(item, header.value)"
                  >
                    <v-icon dense>mdi-pencil</v-icon>
                  </v-btn>
                </td>
              </template>
            </template>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <LoadingPercentDialog
      v-model="isLoadingDialog"
      :final="loadingFinal"
      :initial="loadingInitial"
    />
    <v-dialog v-model="isGotoSendSettingTask" persistent max-width="500px">
      <v-card>
        <v-card-title class="primary--text">{{ $t('task.create_approve_setting_success') }}</v-card-title>
        <v-card-text class="py-5">
          <div
            style="text-indent:15px;"
          >{{ $t('task.create_approve_setting_success_description_1') }}</div>
          <div
            style="text-indent:15px;"
          >{{ $t('task.create_approve_setting_success_description_2') }}</div>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn @click="isGotoSendSettingTask = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" to="settingtask-areaacc" @click="isGotoSendSettingTask = false">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('task.goto_approve_setting_task') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isSelectLists" persistent max-width="600px">
      <v-card>
        <v-card-title
          class="green white--text" v-if="form.item">{{ $t('market.setting_stall') }} {{form.item.area ? form.item.area.name : '-'}}</v-card-title>
        <v-card-title class="white--text" :class="eventModal == 'delete' ? 'error' : 'green'" v-else>
          {{eventModal == 'delete' ? $t('delete_settings') : $t('add_settings')}} {{selectAreas.length}} {{ $t('area.title') }}
        </v-card-title>
        <v-card-text class="py-5">
          <div class="mb-3">
            <v-select
              :disabled="form.item ? true : false"
              :items="accountingItemsLists"
              :label="$t('market.setting_list_stall')"
              background-color="grey lighten-4"
              outlined
              hide-details
              v-model="form.accountingProductId"
            ></v-select>
          </div>
          <template v-if="eventModal != 'delete'">
            <template v-if="hashAccountingProduct[form.accountingProductId]">
              <div v-if="hashAccountingProduct[form.accountingProductId].type != 'discount'">
                <div class="d-flex justify-space-between align-center flex-nowrap">
                  <v-currency-field
                    :label="$t('market.price') + ' (' + $helper.currencyThEn(tabType) + ')'"
                    step="1"
                    background-color="white"
                    v-model="form.cost"
                    outlined
                    hide-details
                  />
                  <h4 class="ms-2">{{ $helper.currencyThEn(tabType) }}</h4>
                </div>
              </div>
              <div v-else>
                <div class="d-flex justify-space-between align-center flex-nowrap">
                  <v-currency-field 
                    :label="$t('market.discount')"
                    step="1"
                    v-model="form.discount"
                    background-color="white"
                    outlined
                    hide-details
                  />
                  <h4 class="ms-2">{{ $helper.currencyThEn(tabType) }}</h4>
                </div>
              </div>
            </template>
          </template>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <template v-if="eventModal != 'delete'">
            <v-btn color="error" @click="dialogCloseDialogConfirm = true" :disabled="isLoadingDialog">
              <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
            </v-btn>
            <v-btn color="success" @click="saveAreaAccountingLists()" :loading="isLoadingDialog" :disabled="!form.accountingProductId">
              <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn @click="dialogCloseDialogConfirm = true" :disabled="isLoadingDialog">
              <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
            </v-btn>
            <v-btn color="error" @click="saveAreaAccountingLists()" :disabled="!form.accountingProductId" :loading="isLoadingDialog">
              <v-icon left>mdi-delete</v-icon>{{ $t('confirm') }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialogComponent v-model="dialogCloseDialogConfirm" :title="$t('close_window')"
      :text="$t('validate.confirm_to_close_window')"
      :textClass="'text-center fs-14'"
      :textBtnOk="$t('confirm')" 
      :textBtnCancel="$t('cancel')"
      :type="'error'"
      @onOk="isSelectLists = false; dialogCloseDialogConfirm = false"
      @onCancel="dialogCloseDialogConfirm = false" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ExportMarketSetting } from "../exports";
import LoadingPercentDialog from "@/components/LoadingPercentDialog.component";
import ConfirmDialogComponent from "./ConfirmDialog.component.vue";
export default {
  components: {
    LoadingPercentDialog,
    ConfirmDialogComponent
  },
  props: {
    isMainLoading: Boolean,
    marketId: String,
    projectId: String,
    areasAccountingItems: Object,
    tabType: String
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    ...mapState({
      areas: state => state.area.areas,
      areaAccountingProducts: state =>
        state.areaAccountingProduct.areaAccountingProducts,
      accountingProducts: state => state.accountingProducts.accountingProducts
    }),
    enableEditAreaAccountingProduct() {
      let res = false;
      if (
        this.admin ||
        (this.employee && this.employee.enableEditAreaAccountingProduct)
      ) {
        res = true;
      }
      return res;
    },
    selectAreas() {
      let select = [];
      if (
        this.areasAccountingItems.items &&
        this.areasAccountingItems.items.length
      )
        select = this.areasAccountingItems.items.filter(
          item => item.isSelected
        );
      return select;
    },
    accountingItemsLists() {
      let lists = [];
      if (
        this.areasAccountingItems.headers &&
        this.areasAccountingItems.headers.length
      )
        lists = this.areasAccountingItems.headers.filter(
          item => item.value != "area.name" && item.value != "area.order"
        );
      return lists;
    },
    hashAccountingProduct(){
      let hash = {}
      for(let accountingProduct of this.accountingProducts){
        hash[accountingProduct.objectId] = accountingProduct
      }
      return hash
    }
  },
  data() {
    return {
      currentNote: "",
      removeAreaId: "",
      settingTaskSelector: [],
      isSendSettingTask: false,
      isGotoSendSettingTask: false,
      isShowSelect: false,
      isLoadingDialog: false,
      loadingInitial: 0,
      loadingFinal: 0,
      isLoading: false,
      formBill: null,
      isSelectLists: false,
      form: {
        accountingProductId: "",
        cost: 0,
        item: undefined,
        discount: 0,
        discountType: 1,
        originalDiscount: 0
      },
      dialogCloseDialogConfirm : false,
      eventModal: "add"
    };
  },
  watch: {},
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.$emit("onInitAreaaccountingproduct");
    },
    updateAreaAccountingProuctDialog(item, accountingProductId) {
      this.form.accountingProductId = accountingProductId;
      if(item[accountingProductId]){
        this.form.cost = item[accountingProductId].cost;
        this.form.discount = item[accountingProductId].discount || 0;
        this.form.discountType = item[accountingProductId].discountType || 1;
        this.form.originalDiscount = item[accountingProductId].originalDiscount || 0;
      }else{
        this.form.cost = 0;
        this.form.discount = 0;
        this.form.discountType = 1;
        this.form.originalDiscount = 1;
      }
      
      this.form.item = item;
      this.isSelectLists = true;
    },
    exportAreaAccounting() {
      this.$emit("onExportAreaAccounting");
    },
    selectAllToggle(value) {
      if (
        this.areasAccountingItems.items.filter(item => item.isSelected)
          .length != this.areasAccountingItems.items.length &&
        value.value
      ) {
        for (let item of this.areasAccountingItems.items) {
          item.isSelected = true;
        }
      } else {
        for (let item of this.areasAccountingItems.items) {
          item.isSelected = false;
        }
      }
    },
    openSelectArea() {
      this.selectAreasClear();
      this.isShowSelect = true;
    },
    selectAreasClear() {
      this.form.cost = 0;
      this.form.discount = 0;
      this.form.discountType = 1;
      this.form.accountingProductId = "";
      this.form.item = undefined;
      for (let item of this.areasAccountingItems.items) {
        item.isSelected = false;
      }
    },
    inputSelectAreas(item, isSelected) {
      item.isSelected = !isSelected;
    },
    settingListClick() {
      this.form.accountingProductId = "";
      this.form.cost = 0;
      this.form.discount = 0;
      this.form.discountType = 1;
      this.form.item = undefined;
      this.isSelectLists = true;
      this.eventModal = "add";
    },
    removeBillingSettings() {
      this.form.accountingProductId = "";
      this.form.cost = 0;
      this.form.discount = 0;
      this.form.discountType = 1;
      this.form.item = undefined;
      this.isSelectLists = true;
      this.eventModal = "delete";
    },
    async saveAreaAccountingLists() {
      let selectAreasLoop = [];
      if (!this.form.item) selectAreasLoop = this.selectAreas;
      else selectAreasLoop = this.form.item ? [this.form.item] : [];
      if (selectAreasLoop && selectAreasLoop.length) {
        this.isLoadingDialog = true;
        this.loadingInitial = 0;
        this.loadingFinal = 0;
        this.loadingInitial = selectAreasLoop.length;
        for (let seleteArea of selectAreasLoop) {
          if (seleteArea.isSelected || this.form.item) {
            this.form.cost = parseFloat(this.form.cost);
            this.form.discount = parseFloat(this.form.discount);
            if(this.eventModal == "delete"){
              if (seleteArea[this.form.accountingProductId]) {
                await this.createSettingTask(
                  {
                    id: seleteArea[this.form.accountingProductId].objectId,
                    areaAccountingProductId: seleteArea[this.form.accountingProductId].objectId,
                    areaId: seleteArea.area.objectId,
                    accountingProductId: this.form.accountingProductId,
                    cost: 0,
                    discount: 0,
                    originalDiscount: 0
                  },
                  "edit",
                  this.loadingInitial - 1 == this.loadingFinal
                );
              }
            }else{
              if (seleteArea[this.form.accountingProductId]) {
                await this.createSettingTask(
                  {
                    id: seleteArea[this.form.accountingProductId].objectId,
                    areaAccountingProductId: seleteArea[this.form.accountingProductId].objectId,
                    areaId: seleteArea.area.objectId,
                    accountingProductId: this.form.accountingProductId,
                    cost: this.form.cost,
                    discount: this.form.discount,
                    discountType: this.form.discountType,
                    originalDiscount: this.form.discount == 2 ? this.$helper.round(this.form.cost * this.form.discount / 100) : this.form.discount
                  },
                  "edit",
                  this.loadingInitial - 1 == this.loadingFinal
                );
              } else {
                await this.createSettingTask(
                  {
                    areaId: seleteArea.area.objectId,
                    accountingProductId: this.form.accountingProductId,
                    cost: this.form.cost,
                    discount: this.form.discount,
                    discountType: this.form.discountType,
                    originalDiscount: this.form.discount == 2 ? this.$helper.round(this.form.cost * this.form.discount / 100) : this.form.discount
                  },
                  "add",
                  this.loadingInitial - 1 == this.loadingFinal
                );
              }
            }
          }
          this.loadingFinal++;
        }
        this.isLoadingDialog = false;
        this.isSelectLists = false;
        this.isShowSelect = false;
        this.selectAreasClear();
        this.initData();
      }
    },
    async createSettingTask(formData, action, isLast = false) {
      formData.currencyCode = this.tabType;
      if (!this.enableEditAreaAccountingProduct) {
        await this.$store.dispatch("settingTask/createSettingTask", {
          ...formData,
          ...{
            marketId: this.marketId,
            action,
            settingTaskType: "area_accounting_product"
          },
          currencyCode: this.tabType
        });
        if (isLast) this.isGotoSendSettingTask = true;
        this.$toast.show({
          content: this.$t('market.setting_price_bill_send', 
            { action: action == "add" 
              ? this.$t('action_type.add') 
              : action == "edit" 
              ? this.$t('action_type.edit') 
              : "-"
            }
          ),
          color: "success"
        });
      } else {
        await this.$store.dispatch(
          "areaAccountingProduct/createUpdateAreaAccountingProduct",
          formData
        );
        this.$toast.show({
          content: this.$t('market.finish_setting_invoice',
            { action: action == "add" 
              ? this.$t('action_type.add') 
              : action == "edit" 
              ? this.$t('action_type.edit') 
              : "-" 
            }
          ),
          color: "success"
        });
      }
    }
  }
};
</script>

<style lang="scss">
.acc-row {
  z-index: 1 !important;
}
.acc-table-non-select{
  td:nth-child(1) {
    background-color: white;
    position: sticky;
    left: 0;
    z-index: 2 !important;
  }
  td:nth-child(2) {
    background-color: white;
    position: sticky;
    left: 80px;
    z-index: 2 !important;
  }
  
  th:nth-child(1){
    background-color: white;
    position: sticky;
    left: 0;
    z-index: 3 !important;
  }
  th:nth-child(2) {
    background-color: white;
    position: sticky;
    left: 80px;
    z-index: 3 !important;
  }
}
.acc-table-select{
  td:nth-child(1) {
    background-color: white;
    position: sticky;
    left: 0;
    z-index: 2 !important;
  }
  td:nth-child(2) {
    background-color: white;
    position: sticky;
    left: 64px;
    z-index: 2 !important;
  }
  td:nth-child(3) {
    background-color: white;
    position: sticky;
    left: 144px;
    z-index: 2 !important;
  }

  th:nth-child(1){
    background-color: white;
    position: sticky;
    left: 0;
    z-index: 3 !important;
  }
  th:nth-child(2) {
    background-color: white;
    position: sticky;
    left: 64px;
    z-index: 3 !important;
  }
  th:nth-child(3) {
    background-color: white;
    position: sticky;
    left: 144px;
    z-index: 3 !important;
  }
}
</style>